import http, { endpoint } from '@/utils/http'

const resize = path => http(endpoint(process.env.UPLOAD_ENDPOINT_PREFIX))
  .post('/resize', { key: path })

const parameterize = value => encodeURIComponent(
  value.toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
)

const uploadUrl = (file, path, platform) => {
  const params = {
    path: ['platforms', platform.id, path].filter(e => e).join('/')
  }
  if (file) {
    params['file_name'] = parameterize(file.name)
    params['file_type'] = encodeURIComponent(file.type)
  }
  return http(endpoint(process.env.UPLOAD_ENDPOINT_PREFIX))
    .post('/', params)
}

const uploadToUrl = (request, file) => new Promise((resolve, reject) => {
  const xhr = new XMLHttpRequest()
  xhr.onprogress = (xhr, progress) => console.log(progress)
  xhr.open('PUT', request.signed_request)
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        resolve({
          url: request.url,
          name: file.name,
          type: file.type
        })
      } else {
        reject(xhr)
      }
    }
  }
  xhr.send(file)
})

const send = ({
  file,
  platform,
  path = null
}) => uploadUrl(file, path, platform)
  .then(({ data }) => uploadToUrl(data, file))
  .then(data => resize(data.url))

export default {
  send
}



// WEBPACK FOOTER //
// ./src/api/upload.js